export default __webpack_public_path__ + "static/media/file-checked.d21ee391.svg";